const GLOBALS = {
  APP_NAME: "PikiLinks",
  BLANK_LINK: "#",
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
};
export default GLOBALS;
